import Vue from 'vue'
import Router from 'vue-router'
import indexHome from '@/components/index'
import detail from '@/components/detail'
import poster from '@/components/poster'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'indexHome',
      component: indexHome
    },{
      path: '/redwood/:id',
      name: 'redWoodDetail',
      component: detail
    },{
      path: '/redwood/:id/poster',
      name: 'posterDetail',
      component: poster
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js